var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconOpenInNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 44H14C8.48 44 4 39.52 4 34V14C4 8.48 8.48 4 14 4H34C39.52 4 44 8.48 44 14V34C44 39.52 39.52 44 34 44ZM14 8C10.7 8 8 10.7 8 14V34C8 37.3 10.7 40 14 40H34C37.3 40 40 37.3 40 34V14C40 10.7 37.3 8 34 8H14ZM30 32C28.9 32 28 31.1 28 30V22.82L19.42 31.4C18.64 32.18 17.38 32.18 16.6 31.4C15.82 30.62 15.82 29.36 16.6 28.58L25.18 20H18C16.9 20 16 19.1 16 18C16 16.9 16.9 16 18 16H30C30.26 16 30.52 16.06 30.76 16.16C31 16.26 31.22 16.4 31.42 16.6C31.62 16.8 31.76 17.02 31.86 17.26C31.96 17.5 32.02 17.74 32.02 18.02V30.02C32.02 31.12 31.12 32.02 30.02 32.02L30 32Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOpenInNew);
export default __webpack_public_path__ + "static/media/icon-open-in-new.a03b2b45.svg";
export { ForwardRef as ReactComponent };